const {
  VITE_APP_AWS_USER_POOL_ID,
  VITE_APP_AWS_USER_POOL_WEB_CLIENT_ID,
} = import.meta.env;

const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: VITE_APP_AWS_USER_POOL_ID,
      userPoolClientId: VITE_APP_AWS_USER_POOL_WEB_CLIENT_ID,
    },
  },
};
export default awsConfig;
